import { createGlobalStyle } from 'styled-components';
import { colorGroup } from './common';

export const Globalstyle = createGlobalStyle`
  @import-normalize;
  html, body{
    height: 100%;
    width: 100%;
    margin:0;
    padding:0;
    font-family: PingFangSC-Regular, PingFang SC;
  }

  #root {
    height: 100%;
    width: 100%;
    background: ${colorGroup.bgPage};
  }
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
		background-color: transparent;
    font-weight: 400;
	}
  .select-label-wrap {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;
    color: #172B4D;
		font-size: 14px;
	}

  /* 表格为空的样式 */
  .ant-spin-nested-loading {
    height: 100%;
    > .ant-spin-container {
      height: 100%;

      > .ant-table-empty {
        height: 100%;

        > .ant-table-container {
          height: 100%;

          > .ant-table-content {
            height: 100%;
            & table {
              height: 100%;
            }
          }
        }
      }
    }
  }	
  .adduser-avatar-wrap {
		.ant-form-item-label {
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}
	}
  .ant-select-item-option-selected:not(.ant-select-item-option-disabled){

  }
  .ant-popover-inner-content{
    padding: 0;
  }

  .ant-popover-arrow {
			display: none;
		}
`;
